import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Settings } from '@mri-platform/shared/core';

@Component({
  selector: 'mri-ie-about-dialog',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './about-dialog.component.html',
  styleUrl: './about-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AboutDialogComponent {
  title = '';

  version = '0.0';
  constructor(titleService: Title, settings: Settings) {
    this.title = titleService.getTitle();
    const version = settings.clientVersion?.split?.('-')?.[0];
    if (version) {
      this.version = version;
    }
  }
}
